var _path, _path2, _circle, _circle2, _circle3, _line, _line2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassroomlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20 C40 20, 35 20, 35 25 L35 55 C35 60, 40 60, 40 60 L70 60 C75 60, 75 55, 75 55 L75 25 C75 20, 70 20, 70 20 Z",
    fill: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20 L70 20 C70 20, 75 20, 75 25 L75 55 C75 55, 75 60, 70 60",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 35,
    r: 6,
    fill: "#EC4899"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 6,
    fill: "#EC4899"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 45,
    r: 6,
    fill: "#EC4899"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 35,
    x2: 45,
    y2: 45,
    stroke: "#EC4899",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 35,
    x2: 65,
    y2: 45,
    stroke: "#EC4899",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 45,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: "bold",
    fill: "#1E293B"
  }, "\n    Tredot\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 65,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#6B7280"
  }, "\n    Students \u2022 Teachers \u2022 Classes\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomlogo);
export default __webpack_public_path__ + "static/media/classroomlogo.fc958187c0fa89389505c1622292f262.svg";
export { ForwardRef as ReactComponent };